import React from 'react';
import hero from '../images/hero.jpg';

const HeroImage = () => (
  <img src={hero} alt="Hero" className="px-20 py-0" />
);

export default HeroImage;
